import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Footnote.st.css.js';
import Divider from '../../../Divider';
import { useBaseModalLayoutContext } from '../../BaseModalLayoutContext';
export const Footnote = ({ dataHook, className, children, skin = 'neutral', }) => {
    const { footnoteClassName, footnote = children } = useBaseModalLayoutContext();
    return ((footnote && (React.createElement("div", { "data-hook": dataHook, className: st(classes.root, {
            skin,
        }, footnoteClassName, className) },
        React.createElement(Divider, null),
        React.createElement("div", { className: classes.innerContent }, footnote)))) ||
        null);
};
Footnote.displayName = 'BaseModalLayout.Footnote';
Footnote.propTypes = {
    /** Specifies a CSS class name to be appended to the component’s root element.
     * @internal
     */
    className: PropTypes.string,
    /** data hook for testing */
    dataHook: PropTypes.string,
    /** a footnote node, to be rendered at the very bottom of the modal */
    footnote: PropTypes.node,
    /** Sets the look and feel of the footnote */
    skin: PropTypes.oneOf(['neutral', 'light']),
};
//# sourceMappingURL=Footnote.js.map